import { Pipe, PipeTransform } from '@angular/core';
import { coerceCurrency, currencyPrefix } from '@marmon/shared/types/common';

@Pipe({
	name: 'currencySymbol',
	standalone: true,
})
export class CurrencySymbolPipe implements PipeTransform {
	transform(value: unknown) {
		return currencyPrefix(coerceCurrency(value));
	}
}
